<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <div  class="content-wrap" v-if="type == 1">
      <img src="../assets/images/innovation/private-board.jpeg" alt="" class="img"/>
    </div>
    <div  class="content-wrap" v-else-if="type == 2">
      <img src="../assets/images/innovation/business-management.jpeg" alt="" class="img"/>
    </div>
    <div  class="content-wrap" v-else-if="type == 3">
      <img src="../assets/images/innovation/3A.jpeg" alt="" class="img"/>
    </div>
    <div  class="content-wrap" v-else-if="type == 4">
      <img src="../assets/images/innovation/ai-intelligence.png" alt="" class="img"/>
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      type:""
    };
  },
  methods: {},
  mounted() {
    this.type = this.$route.query.type;
  }
};
</script>
<style scoped>
.content-wrap img {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/innovation.vue